import { useAuthenticatedFetch } from "./useAuthenticatedFetch.js";
import { useMemo } from "react";
import { useMutation } from "react-query";

export const useAppMutation = <
  TData = unknown,
  TError = unknown,
  TVariables = any,
  TContext = unknown
>({
  url,
  fetchInit = { method: "POST", headers: { "Content-Type": "application/json" } },
  reactMutationOptions
}) => {
  const authenticatedFetch = useAuthenticatedFetch();
  const fetch = useMemo(() => {
    return async (variables) => {
      const response = await authenticatedFetch(url, { ...fetchInit, body: JSON.stringify(variables) });
      if (!response.ok) {
        const res = await response.json();
        throw res?.error ? res.error : new Error("Error");
      }
      if (response.headers.get('Content-Type') === "text/csv; charset=utf-8") {
        const blob = await response.blob()
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'actions.csv'
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
      }
      return response.json();
    };
  }, [url, JSON.stringify(fetchInit)]);

  return useMutation<TData, TError, TVariables, TContext>(url, fetch, {
    ...reactMutationOptions
  });
};
